import { FilterButton as GenericFilterButton } from '../../../components/FilterButton';
import UsageTracker from '../../../../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
export const FilterButton = ({
  isFilterActive,
  onClear,
  children,
  filterType
}) => {
  const handleClear = () => {
    onClear();
    if (filterType) {
      UsageTracker.track('teamInteraction', {
        action: 'remove-filter',
        type: filterType
      });
    }
  };
  return /*#__PURE__*/_jsx(GenericFilterButton, {
    isFilterActive: isFilterActive,
    onClear: handleClear,
    testId: filterType ? `remove-${filterType}-filter` : undefined,
    children: children
  });
};